/* ================================================== */
/* CLAMP > Init
/* ================================================== */

function clampMovieTitle() {
	$('.movie__title').each(function(index, element){
		$clamp(element, { clamp: 2 });
	});
}

$(document).ready(function() {
	clampMovieTitle();
});

$(window).on('resize orientationchange', function() {
	clampMovieTitle();
});